<template>
  <div class="mobile-layout" :style="getBgStyle()">
    <div class="hint">
      {{ $t('geng-duo-nei-rong-qing-qian-wang-dian-nao-duan-mian-fei-ti-yan') }}
    </div>
    <slot />
    <div class="contact" @click="showContact">{{ $t('lian-xi-wo-men') }}</div>
  </div>
</template>

<script lang="ts" setup>
import Resource from '~/components/resource';

const runtime = useRuntimeConfig();

const showContact = () => {
  Modal.confirm({
    footer: false,
    icon: null,
    centered: true,
    width: 260,
    maskClosable: true,
    wrapClassName: 'xmov-empty-modal contact-modal',
    content: () =>
      h(Resource, {
        style: { width: '100%' },
        src: 'https://official-site.youyan3d.com/youyan-platform/png/qrcode/drainage/mobile-contact-1.jpeg',
      }),
    closable: false,
  });
};

const getBgStyle = () => {
  return {
    backgroundImage: `url(${transformImage(getFeUrl('/youyan-platform/png/h5/h5-bg.png'))})`,
  };
};
</script>

<style lang="scss" global>
.contact-modal {
  .ant-modal-confirm-content {
    border-radius: 10px;
    overflow: hidden;
  }
  .ant-modal-content {
    padding: 4px;
    img {
      width: 100%;
      margin-bottom: -6px;
    }
  }
}
</style>

<style lang="scss" scoped>
.contact {
  position: fixed;
  right: 0;
  bottom: 50%;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px 4px;
  border-radius: 5px 0 0 5px;
  border: 1px solid #efefef;
  background-color: #ffffff;
  writing-mode: vertical-lr;
  color: var(--black-1);
}
.qrcode {
  position: fixed;
}
.mobile-layout {
  background-size: 100% auto;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  overflow: auto;
}

.hint {
  background: rgb(205, 203, 255, 0.67);
  height: m-rem(32);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 1px m-rem(8) 0px rgba(110, 127, 252, 0.1);
  font-weight: 400;
  font-size: m-rem(12);
  color: var(--text-1-80);
  text-align: center;
}
</style>
